import gql from 'graphql-tag';

export default gql`
query GetConfig(
        $hash: String!
        ) {
    getConfig(
        hash: $hash
    ) {
        hash
        verListApps
    }
}
`;
